import React from 'react';
import { Box, CardMedia, Container, Stack, Typography } from '@mui/material';
import { useDevice } from '../../hooks/useResponsive';
import GradientCTAButton from './InspectionButton';

const Backed12Year = () => {
  const { isMobile } = useDevice();

  return (
    <>
      <Container sx={{ pb: 6, px: isMobile ? 2 : 0.8, backgroundColor: 'white' }}>
        <CardMedia
          component="img"
          className=""
          src="assets/images/Inspection/12.webp"
          alt="Card Image"
          // height={isMobile ? 25 : 40}
          sx={{ objectFit: 'contain', borderRadius: '10px' }}
        />
        <Stack pt={2} pb={3} pr={7} px={1.5}>
          <Typography mb={0.5} color="#000000" fontSize="24px" fontWeight="800" lineHeight={1.2}>
            Backed by 12 Years <br /> of Happy Drives
          </Typography>
          <Typography fontSize="11px" color="#000000" fontWeight="400">
            For over 12 years, FOCUS Motors has been the trusted name in quality car inspections and customer
            satisfaction.
          </Typography>
          <Box mt={2}>
            <Typography color="#000000" fontSize="11px">
              🚗 12+ years of automotive expertise
            </Typography>
            <Typography color="#000000" fontSize="11px">
              🌟 Thousands of happy customers
            </Typography>
            <Typography color="#000000" fontSize="11px">
              🛠️ Trusted for reliable, in-depth inspections
            </Typography>
          </Box>
        </Stack>

        <GradientCTAButton text="Book with the Experts" />
      </Container>
    </>
  );
};

export default Backed12Year;
